import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/weightprice/`;

const getWeightPriceItems = async (status = 'all') => {
    return await axios.get(API_URL, { params: { status } });
};

const addWeightPriceItem = async (weightPriceData) => {
    return await axios.post(API_URL, weightPriceData);
};

const editWeightPriceItem = async (id, updatedData) => {
    return await axios.put(API_URL + id, updatedData);
};

const deleteWeightPriceItem = async (id) => {
    return await axios.delete(API_URL + id);
};

export default {
    getWeightPriceItems,
    addWeightPriceItem,
    editWeightPriceItem,
    deleteWeightPriceItem
};

